// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"382b0bcd","453":"1bc4f8fd","455":"b5ad7bf4","977":"d353ebac"}[chunkId] + ".chunk.js";
};